module.exports = __webpack_public_path__ + "static/img/game_ctl_demo.8136620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prj/game_ctl_demo.png
// module id = oJkJ
// module chunks = 1